import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import Button from '../../../components/Button';
import CircledIcon from '../../../components/CircledIcon';
import DatePickerInput from '../../../components/DatePicker/DatePicker';
import { useNavigate } from 'react-router-dom';
import { HEALTH_INSURANCE_ROUTH } from '../../../routes/types';

export type ReportEventModalProps = React.PropsWithChildren<{
  handleCloseModal?: () => void;
  onDateChange: (e: any) => void;
  value?: string | number;
  showModal?: boolean;
}>;

const ReportEventModal = ({
  handleCloseModal,
  onDateChange,
  value,
  showModal,
}: ReportEventModalProps) => {
  const navigate = useNavigate();

  const handleDateChange = (e: any) => {
    onDateChange(e);
  };

  return (
    <Modal size={'lg'} show={showModal} onHide={handleCloseModal}>
      <Container className={'p-7 p-lg-12'}>
        <Modal.Header className={'border-0 ms-0 me-0 pt-0 pb-12'} closeButton>
          <Modal.Title className={'  h6 fw-normal'}>
            <Row>
              <Col className={'d-flex align-items-center'}>
                <CircledIcon
                  variant={'icon-emphasized'}
                  icon={light('baby-carriage')}
                />
                <h4 className={'ms-7 mb-0 text-sm-20-lg-32'}>Report Event</h4>
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Row>
          <Col className={'mb-10 col-12'}>
            <DatePickerInput
              maxWidth={'313px'}
              onChange={handleDateChange}
              placeholder={'Select a date'}
              label={'Enter the date your new child was born or adopted'}
              isValid={value !== undefined}
            />
          </Col>
        </Row>
        <Row
          className={
            'd-flex flex-column-reverse flex-lg-row justify-content-center'
          }
        >
          <Col className={'col-12 col-lg-3'}>
            <Button
              onClick={handleCloseModal}
              className={'col-12'}
              variant={'primary-outline'}
            >
              Cancel
            </Button>
          </Col>
          <Col className={'col-12 col-lg-3 mb-7'}>
            <Button
              onClick={() => navigate(HEALTH_INSURANCE_ROUTH)}
              className={'col-12'}
            >
              Continue
            </Button>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};

export default ReportEventModal;
